import React from 'react';
import { Typography, Button } from '@one-thd/sui-atomic-components';
import { useInstantCheckout } from '../../../hooks/use-instant-checkout';
export const NoMethodCard = ({ onSetUp, ctaText, missingMethod, }) => {
    const { isEnrolled } = useInstantCheckout();
    const textColor = isEnrolled ? 'primary' : 'inactive';
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-col-span-12 sui-gap-6" },
        React.createElement("div", null,
            React.createElement(Typography, { weight: "bold", color: textColor },
                "You haven\u2019t saved ",
                missingMethod,
                "."),
            React.createElement("div", { className: "sui-mt-2" },
                React.createElement(Typography, { color: textColor },
                    "Add ",
                    missingMethod,
                    " for quick and easy checkout the next time you shop."))),
        ctaText && (React.createElement("div", { className: "sui-col-span-12 sui-grid md:sui-grid-cols-9" },
            React.createElement("div", { className: "md:sui-pr-4 sui-col-span-12 md:sui-col-span-4 2xl:sui-col-span-3" },
                React.createElement(Button, { onClick: onSetUp, fullWidth: true }, ctaText))))));
};
